module.exports = __webpack_public_path__ + "img/tech.e251d50f.jpg";